import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import "../../styles/GlobalStyles.css";
// import PersonalProfile from "../../components/PersonalProfile"; // ✅ ADDED

const ManageUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // ✅ ADDED FOR EDIT DRAWER
  // const [selectedUser, setSelectedUser] = useState(null);
  // const [openDrawer, setOpenDrawer] = useState(false);
  // const [editUser, setEditUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUsers(currentPage);
  }, [currentPage]);

  const fetchUsers = async (page = 1) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/profile/allCandidates?page=${page}&limit=10`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.candidates) {
        setUsers(res.data.candidates);
        setTotalPages(res.data.totalPages || 1);
      } else if (Array.isArray(res.data)) {
        setUsers(res.data);
      } else {
        setUsers([]);
      }
    } catch (err) {
      console.error("Failed to fetch candidates", err);
      // alert("Failed to load candidates");
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  /* ================= ACTIONS ================= */

  // ✅ UPDATED EDIT HANDLER
  const handleEdit = (candidate) => {
    navigate(`/admin/edit-candidate/${candidate._id}`);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this candidate?")) return;

    try {
      const token = localStorage.getItem("token");

      await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/admin/deleteCandidate/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      alert("Candidate deleted successfully");
      fetchUsers(currentPage);
    } catch (err) {
      console.error("Delete failed", err);
      alert("Failed to delete candidate");
    }
  };

  const handleApprove = async (id) => {
    try {
      const token = localStorage.getItem("token");

      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/admin/approve/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Candidate approved successfully");
      fetchUsers(currentPage); // refresh list
    } catch (err) {
      console.error("Approve failed", err);
      alert("Failed to approve candidate");
    }
  };

  const handleReject = async (id) => {
    const reason = prompt("Enter rejection reason:");
    if (!reason) return;

    try {
      const token = localStorage.getItem("token");

      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/admin/reject/${id}`,
        { reason },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Candidate rejected successfully");
      fetchUsers(currentPage); // refresh list
    } catch (err) {
      console.error("Reject failed", err);
      alert("Failed to reject candidate");
    }
  };
  const getHighestQualification = (education = []) => {
    if (!education.length) return "-";

    const normalize = (value = "") =>
      value.toLowerCase().replace(/\s|\/|-/g, "");

    const priority = [
      { key: "phd", label: "PhD" },
      { key: "masters", label: "Masters" },
      { key: "graduation", label: "Graduation" },
      { key: "12th", label: "12th" },
      { key: "10th", label: "10th" },
    ];

    for (const p of priority) {
      const found = education.find(e =>
        normalize(e.education).includes(p.key)
      );
      if (found) return p.label;
    }

    return education[education.length - 1].education;
  };



  return (
    <div className="p-6">
      <h1 className="mb-6 text-2xl font-semibold text-center">
        Manage Candidates
      </h1>


      {loading ? (
        <p>Loading candidates...</p>
      ) : users.length === 0 ? (
        <p className="text-gray-500">No candidates found.</p>
      ) : (
        <div className="admin-table-wrapper">
          <div className="admin-table-scroll">
            <table className="admin-table">

              <thead className="bg-gray-100">
                <tr>
                  <th className="p-3">Sl No</th>
                  <th className="p-3 ">Candidate Name</th>
                  <th className="p-3 ">Contact No</th>
                  <th className="p-3 ">Alternate No</th>
                  <th className="p-3 ">Mail ID</th>
                  <th className="p-3 ">Qualification</th>
                  <th className="p-3 ">Experience</th>
                  <th className="p-3 ">Salary</th>
                  <th className="p-3 ">Notice Period</th>
                  <th className="p-3 ">City</th>
                  <th className="p-3 ">Location</th>
                  <th className="p-3 ">Preferred Job Location</th>
                  <th className="p-3 ">Actions</th>
                </tr>
              </thead>

              <tbody>
                {users.map((u, index) => (
                  <tr key={u._id} className="border-t hover:bg-gray-50">
                    <td className="p-3 text-center">{(currentPage - 1) * 10 + index + 1}</td>
                    <td className="p-3">
                      {u.first_name || "-"} {u.last_name || ""}
                    </td>

                    <td className="p-3">
                      {u.phone_number ? String(u.phone_number) : "-"}
                    </td>
                    {/* {console.log("DEBUG PHONE:", u.phone_number, typeof u.phone_number)} */}
                    <td className="p-3">
                      {u.alternate_no ? String(u.alternate_no) : "-"}
                    </td>
                    <td className="p-3">{u.email || "-"}</td>

                    <td className="p-3">
                      {u.qualification?.qualification || getHighestQualification(u.education)}
                    </td>

                    <td className="p-3">
                      {u.experience || u.work_preference?.experience || "-"}
                    </td>

                    <td className="p-3">
                      {u.salary || u.work_experience?.[0]?.salary || "-"}
                    </td>

                    <td className="p-3">
                      {u.notice_period || u.work_preference?.notice_period || "-"}
                    </td>

                    <td className="p-3">{u.address?.city || "-"}</td>

                    <td className="p-3">
                      {u.address?.area || u.address?.state || "-"}
                    </td>

                    <td className="p-3">
                      {u.work_preference?.preferred_location || "-"}
                    </td>

                    <td className="admin-table-actions">


                      <button
                        className="btn-edit"
                        onClick={() => handleEdit(u)}
                      >
                        Edit
                      </button>

                      {u.status === "pending" && (
                        <>
                          <button
                            className="btn-approve"
                            onClick={() => handleApprove(u._id)}
                          >
                            Approve
                          </button>

                          <button
                            className="btn-reject"
                            onClick={() => handleReject(u._id)}
                          >
                            Reject
                          </button>
                        </>
                      )}

                      {u.status === "approved" && (
                        <span className="status-badge status-approved">Approved</span>
                      )}

                      {u.status === "rejected" && (
                        <div className="flex items-center gap-2">
                          <span className="status-badge status-rejected">Rejected</span>
                          <button
                            className="btn-approve"
                            onClick={() => handleApprove(u._id)}
                          >
                            Approve
                          </button>
                        </div>
                      )}

                      <button
                        className="btn-delete"
                        onClick={() => handleDelete(u._id)}
                      >
                        Delete
                      </button>
                    </td>


                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* PAGINATION CONTROLS */}
          <div className="flex justify-center items-center mt-6 gap-2">
            <button
              className="px-3 py-1 border rounded hover:bg-gray-100 disabled:opacity-50"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Prev
            </button>

            {/* Sliding Window Pagination */}
            {(() => {
              const maxButtons = 8;
              let start = Math.max(1, currentPage - Math.floor(maxButtons / 2));
              let end = Math.min(totalPages, start + maxButtons - 1);

              if (end - start + 1 < maxButtons) {
                start = Math.max(1, end - maxButtons + 1);
              }

              const pages = [];
              for (let i = start; i <= end; i++) pages.push(i);

              return pages.map(page => (
                <button
                  key={page}
                  className={`px-3 py-1 border rounded ${currentPage === page ? 'bg-blue-600 text-white' : 'hover:bg-gray-100'}`}
                  onClick={() => setCurrentPage(page)}
                >
                  {page}
                </button>
              ));
            })()}

            <button
              className="px-3 py-1 border rounded hover:bg-gray-100 disabled:opacity-50"
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>

        </div>

      )}


      {/* ================= EDIT DRAWER ================= */}
      {/* ================= EDIT DRAWER (Disabled/Removed) ================= */}
      {/* {openDrawer && selectedUser && (
        <>
          <div
            className="profile-backdrop"
            onClick={() => setOpenDrawer(false)}
          />

          <div className="profile-drawer">
            <button
              className="drawer-close-btn"
              onClick={() => setOpenDrawer(false)}
            >
              ✕
            </button>
          </div>
        </>
      )} */}
    </div >
  );
};

export default ManageUsers;
